import ActionButtons from 'components/Content/Happening/ActionButtons/ActionButtons';

import { withActionButtonsProps } from 'viewModel/happening/withActionButtonsProps';

export default withActionButtonsProps(ActionButtons);
